var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'media-links',
    'pt-2xl',
    'px-2xl',
    _vm.dimensions.width < 600 ? 'hide' : ''
  ]},_vm._l((_vm.children),function(item){return _c('a',{key:item.title,staticClass:"media-links--thumb",attrs:{"href":"#media-link"},on:{"click":function($event){$event.preventDefault();return _vm.clickHandler(item)}}},[_c('div',{staticClass:"media-links--thumb--img"},[_c('i',{class:[
          'media-icon',
          'fal',
          _vm.isVideo(item) ? 'fa-play-circle' : 'fa-plus'
        ]}),_c('img',{attrs:{"src":_vm.parseSrc(item.image),"alt":item.title}})]),(item.title)?_c('h5',{domProps:{"textContent":_vm._s(item.title)}}):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }